import { SeccionesRolesEnum } from '@/core/enum/RolSeccions.enum';
import { RoleAccessService } from '@/core/service/role-access/role-access.service';
import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, firstValueFrom, map, take } from 'rxjs';

export const fuelOrderGuard: CanActivateFn = async () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);
  const rolesService = inject(RoleAccessService);

  return await firstValueFrom(
    combineLatest([toObservable(userStore.isLoaded), toObservable(userStore.isPblAsrResolved)]).pipe(
      filter(([loaded, asrResolved]) => loaded && asrResolved),
      take(1),
      map(() => {
        const canPass =
          (userStore.isFuels() || userStore.isAxionSmart() || userStore.isTransporte()) &&
          !userStore.isAsrUser() &&
          !userStore.isMarineInternacional() &&
          rolesService.isVisibleForRol(SeccionesRolesEnum.PEDIDOS_NUEVO_PEDIDO_LIQUIDO);

        return canPass ? true : router.createUrlTree(['/portal/home']);
      }),
    ),
  );
};
